import { $host } from ".";

export const sendMail = async (formData) => {
    try {
        const { data } = await $host.post('api/mail', formData);
        return data;
    } catch (error) {
        console.error("Error sending message:", error);
        return error;
    }
};
